// extracted by mini-css-extract-plugin
module.exports = {"root":"DetailsHeader_root__gqm48","text":"DetailsHeader_text__2BcQH","searchMoreLink":"DetailsHeader_searchMoreLink__3dClr"};